import { useTranslation } from 'next-i18next/pages';

import useCurrentLang from '@/hooks/apps/useCurrentLang';

import ContentTitle from '@/components/apps/ui/title/ContentTitle';

import SolutionFeature from './SolutionFeature';
import SolutionImage from './SolutionImage';
import SolutionInfo from './SolutionInfo';
import SolutionMike from './SolutionMike';
import { SolutionItemProps } from './solutionItemTypes';

export default function SolutionItem({
  title,
  description,
  image,
  infoItems,
  feature,
  mike,
  isDesktop,
  index,
  idPrefix,
}: SolutionItemProps) {
  const currentLang = useCurrentLang();
  const { t } = useTranslation('common');

  return (
    <div
      key={index}
      id={`${idPrefix}-${index + 1}`}
      className="flex flex-col gap-10 lg:gap-[clamp(40px,5vw,60px)]"
    >
      <ContentTitle title={title} description={description} />
      {image && (
        <div className="flex flex-col gap-6">
          <SolutionImage
            alt={typeof title === 'string' ? t('{{title}} 구성도', { title }) : ''}
            desktop={image.desktop}
            language={currentLang}
            mobile={image.mobile}
          />
          {infoItems && <SolutionInfo infoItems={infoItems} />}
        </div>
      )}
      {feature && <SolutionFeature feature={feature} />}
      {mike && <SolutionMike mike={mike} isDesktop={isDesktop} />}
    </div>
  );
}
